type Props = {
  tone: "error" | "success" | "info";
  children: React.ReactNode;
};

const styles: Record<Props["tone"], React.CSSProperties> = {
  error: {
    background: "rgba(232, 111, 78, 0.12)",
    border: "1px solid rgba(232, 111, 78, 0.45)",
    color: "#9a3514",
  },
  success: {
    background: "rgba(34, 176, 166, 0.12)",
    border: "1px solid rgba(34, 176, 166, 0.45)",
    color: "#0d6a63",
  },
  info: {
    background: "rgba(18, 63, 56, 0.06)",
    border: "1px solid rgba(18, 63, 56, 0.18)",
    color: "var(--c-palm)",
  },
};

export default function FormMessage({ tone, children }: Props) {
  return (
    <div
      role={tone === "error" ? "alert" : "status"}
      style={{
        ...styles[tone],
        borderRadius: "var(--r-sm)",
        padding: "0.75rem 0.9rem",
        fontSize: "0.92rem",
        marginBottom: "1rem",
        lineHeight: 1.45,
      }}
    >
      {children}
    </div>
  );
}
